/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Retention_6Inputs */

const da_privacy_retention_6 = /** @type {(inputs: Privacy_Retention_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betalinger og fakturaer: op til fem år, fordi bogføringsloven kræver det.`)
};

/** @type {(inputs: Privacy_Retention_6Inputs) => LocalizedString} */
const en_privacy_retention_6 = da_privacy_retention_6;

/**

* @param {Privacy_Retention_6Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const privacy_retention_6 = /** @type {((inputs?: Privacy_Retention_6Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Retention_6Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_privacy_retention_6(inputs)
	return /** @type {LocalizedString} */ ("Betalinger og fakturaer: op til fem år, fordi bogføringsloven kræver det.")
});